import { Stack } from '@mantine/core';
import { useFormikContext } from 'formik';
import { useMemo, useState } from 'react';
import { DateRange, DateRangeFormData, DEFAULT_SELECTED_DATE_RANGE, FIXED_DATE_RANGES, isEqualDateRange } from './utils';
import { sidebar } from './styles';

export function Sidebar({ onClick }: { onClick?: (arg: typeof FIXED_DATE_RANGES[0]) => void }) {
  const [selectedRange, setSelectedRange] = useState(DEFAULT_SELECTED_DATE_RANGE.title);

  const onSidebarTabClick = (item: typeof FIXED_DATE_RANGES[0]) => {
    setSelectedRange(item.title);
    onClick?.(item);
  };

  return (
    <Stack className={sidebar} sx={{ gap: 4 }}>
      {FIXED_DATE_RANGES.map((item) => (
        <SidebarTab
          isActive={item.title === selectedRange}
          key={`${item.title}-fixed-range`}
          range={item.range}
          onClick={() => onSidebarTabClick(item)}
        >
          {item.title}
        </SidebarTab>
      ))}
    </Stack>
  );
}

function SidebarTab({
  children,
  range = DEFAULT_SELECTED_DATE_RANGE.range,
  onClick,
  isActive,
}: {
  children: string;
  range?: DateRange;
  onClick?: () => void;
  isActive: boolean;
}) {
  const form = useFormikContext<DateRangeFormData>();
  const isSelected = useMemo(() => isEqualDateRange(form.values.range, range), [form.values.range, range]);

  return (
    <button
      className="sidebar-tab"
      data-selected={isSelected && isActive}
      onClick={() => {
        form.setFieldValue('range', range);
        onClick?.();
      }}
      type="button"
    >
      {children}
    </button>
  );
}
